'use strict';

import './index.less';

import React from 'react';
import classnames from 'classnames';

export enum TabTheme {
	SWITCH = 'switch',
	DARK = 'dark',
	HEADER = 'header',
	FORMAL = 'formal'
}

export interface TabInterface {
	id: string;
	title?: string;
	description?: string;
	icon?: string;
	background?: string;
	colour?: string;
	activeColour?: string;
	disabled?: boolean;
	tagText?: string;
	handleClick?: (id: string) => void;
}

export interface TabProps extends TabInterface {
	selected: boolean;
	theme: TabTheme;
	styles?: string;
	handleClick: (id: string) => void;
}

export const Tab = ({
	id,
	title,
	description,
	icon,
	background,
	colour = 'white',
	tagText,
	selected,
	handleClick,
	disabled = false,
	theme = TabTheme.SWITCH
}: TabProps) => (
	<div
		id={'Tab-' + id}
		className={classnames(
			'Tab',
			selected && `Tab--selected`,
			`Tab--${colour}`,
			disabled && 'Tab--disabled',
			theme && `Tab--theme-${theme}`
		)}
		style={
			!selected && background
				? {
						backgroundImage: `url(${background})`
				  }
				: {}
		}
		onClick={() => {
			!disabled && handleClick && handleClick(id);
		}}
	>
		{icon && (
			<div className="Tab__icon">
				<img src={icon} />
			</div>
		)}
		{title && (
			<div
				className={classnames(
					'Tab__title',
					`Tab--theme-${theme}__title`,
					!description && `Tab-text--centred`
				)}
			>
				{title}
			</div>
		)}
		{description && (
			<div className={`Tab__description Tab--theme-${theme}__description`}> {description} </div>
		)}
		{tagText && <div className={`Tab__tagText Tab--theme-${theme}__description`}>{tagText}</div>}
	</div>
);
